import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";

type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      intlMessages,
      slug: ctx.params.slug,
      defaultCanonicalRoute: routes.checkInWithSlug(ctx.params.slug),
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export { Informations as default } from "@/components/pages/checkIn/rental/informations/Informations";
